export enum UserSubscriptionMethod {
	Content = 'Content',
	WebexTeams = 'WebexTeams'
}
